var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FFInputText } from './elements/text/text';
import { FFInputNumber } from './elements/number/number';
import { FFCheckbox } from './elements/checkbox/checkbox';
import { FFRadioButton } from './elements/radio/radio';
import { FFInputDate } from './elements/date/date';
import { FFSelect } from './elements/select/select';
import { FFInputEmail } from './elements/email/email';
import { FFInputPhone } from './elements/phone/phone';
export function renderFields(fields) {
    if (fields === void 0) { fields = []; }
    return fields.map(function (field, key) {
        switch (field.type) {
            case 'text': {
                return React.createElement(FFInputText, __assign({ key: key }, field));
            }
            case 'number': {
                return React.createElement(FFInputNumber, __assign({ key: key }, field));
            }
            case 'checkbox': {
                return React.createElement(FFCheckbox, __assign({ key: key }, field));
            }
            case 'radio': {
                return React.createElement(FFRadioButton, __assign({ key: key }, field));
            }
            case 'password': {
                return React.createElement(FFInputText, __assign({ key: key }, field));
            }
            case 'date': {
                return React.createElement(FFInputDate, __assign({ key: key }, field));
            }
            case 'select': {
                return React.createElement(FFSelect, __assign({ key: key }, field));
            }
            case 'phone': {
                return React.createElement(FFInputPhone, __assign({ key: key }, field));
            }
            case 'email': {
                return React.createElement(FFInputEmail, __assign({ key: key }, field));
            }
            default: {
                console.error("Incorrect field type: " + field.type);
                return null;
            }
        }
    });
}
//# sourceMappingURL=renderFields.js.map